/**
 * Testi italiani della pagina «Listino» dell'amministrazione (ADR 0058).
 */

/** Testi del listino. */
export const priceList = {
  /** Voce di menu e scheda. */
  tab: 'Listino',
  /** Titolo della pagina. */
  title: 'Listino',
  /** Sottotitolo. */
  subtitle: 'Prezzi e limiti dei piani, prezzi a consumo. Una versione pubblicata non cambia più.',
  /** Lettura non riuscita. */
  loadFailed: 'Lettura del listino non riuscita. Riprova.',
  /** Versione in vigore. */
  activeVersion: 'Versione in vigore: {{version}}, pubblicata il {{when}} da {{by}}',
  /** C'è una bozza salvata. */
  draftSaved: 'Bozza salvata: versione {{version}}, non ancora pubblicata.',
  /** Bozza con modifiche non salvate. */
  unsaved: 'Modifiche non salvate.',
  /** Schede. */
  tabs: {
    plans: 'Piani',
    usage: 'Consumo',
    models: 'Modelli',
    margin: 'Margine',
    history: 'Storico',
  },
  /** Colonne dei piani. */
  plans: {
    field: 'Voce',
    free: 'Free',
    base: 'Base',
    premium: 'Premium',
  },
  /** Nomi delle voci di un piano. */
  fields: {
    price_cents: 'Canone al mese (€, IVA inclusa)',
    max_sets: 'Set',
    max_projects_per_set: 'Progetti per set',
    monthly_token_limit: 'Token al mese (milioni)',
    monthly_input_tokens: 'Token di input al mese (milioni)',
    monthly_output_tokens: 'Token di output al mese (milioni)',
    monthly_cache_tokens: 'Token di cache al mese (milioni)',
    monthly_voice_minutes: 'Minuti di voce al mese',
    max_set_members: 'Membri per set',
    production_sites: 'Produzione pubblica',
    max_custom_domains: 'Domini per produzione',
    hosting_storage_gib: 'Spazio per sito (GiB)',
    set_storage_gib: 'Spazio per set (GiB)',
    max_agent_size: 'Taglia massima degli agenti',
  },
  /** Taglie. */
  sizes: {
    small: 'Piccola',
    medium: 'Media',
    large: 'Grande',
  },
  /** Prezzi a consumo. */
  usage: {
    token_block_cents: 'Blocco di 100.000 token oltre la quota (€)',
    voice_minute_cents: 'Minuto di voce oltre la quota (€)',
    storage_gib_month_cents: 'GiB di spazio al mese oltre l’incluso (€)',
    default_spending_cap_cents: 'Tetto mensile proposto all’utente (€)',
    max_spending_cap_cents: 'Tetto mensile massimo (€)',
    help: 'Valgono per i crediti prepagati e, dalla fase 2, per il pagamento a fine mese.',
  },
  /** Costi stimati. */
  costs: {
    title: 'Costi stimati',
    help: 'Servono solo a calcolare il margine: nessuno li addebita.',
    token_million_usd: 'Costo di un milione di token ($)',
    voice_minute_usd: 'Costo di un minuto di voce ($)',
    storage_gib_month_usd: 'Costo di un GiB al mese ($)',
    eur_usd: 'Dollari per un euro',
    vat_rate: 'IVA compresa nei prezzi (%)',
  },
  /** Margine. */
  margin: {
    share: 'Quota usata',
    shareHelp: 'Parte della quota dei token e della voce che l’utente consuma in media.',
    plan: 'Piano',
    revenue: 'Incasso netto ($)',
    tokens: 'Token ($)',
    voice: 'Voce ($)',
    margin: 'Margine ($)',
    full: 'Con l’uso pieno',
    average: 'Con la quota scelta',
  },
  /** Storico. */
  history: {
    version: 'Versione',
    when: 'Pubblicata',
    by: 'Da',
    note: 'Nota',
    empty: 'Nessuna versione pubblicata.',
  },
  /** Comandi. */
  actions: {
    save: 'Salva bozza',
    discard: 'Scarta bozza',
    publish: 'Pubblica',
    apply: 'Applica agli abbonati',
    saved: 'Bozza salvata.',
    discarded: 'Bozza scartata.',
    published: 'Versione {{version}} pubblicata.',
    saveFailed: 'Salvataggio non riuscito. Controlla i valori e riprova.',
    publishFailed: 'Pubblicazione non riuscita. Riprova.',
    applyFailed: 'Operazione non riuscita. Riprova.',
  },
  /** Finestra della pubblicazione. */
  publish: {
    title: 'Pubblicare la versione {{version}}?',
    changes: 'Che cosa cambia',
    noChanges: 'La bozza è uguale alla versione in vigore.',
    subscribers: 'Abbonati oggi: Base {{base}}, Premium {{premium}}. Tengono il prezzo di oggi finché non usi «Applica agli abbonati».',
    tokensLater: 'Un tetto dei token più basso vale dal primo del mese prossimo.',
    note: 'Nota',
    notePlaceholder: 'Che cosa cambia e perché',
    code: 'Codice dell’app di autenticazione',
    confirm: 'Pubblica',
    from: 'da {{from}} a {{to}}',
    usageScope: 'Consumo',
    costsScope: 'Costi',
  },
  /** Finestra di «Applica agli abbonati». */
  apply: {
    title: 'Applicare i prezzi in vigore agli abbonati?',
    text: 'Gli abbonati con un prezzo vecchio passano al prezzo in vigore dal primo rinnovo dopo {{days}} giorni. Avvisali prima: l’avviso automatico arriva con la fase 2.',
    confirm: 'Applica',
    done_one: '{{count}} abbonato passerà al prezzo nuovo tra {{days}} giorni.',
    done_other: '{{count}} abbonati passeranno al prezzo nuovo tra {{days}} giorni.',
  },
  /** Errori con codice. */
  errors: {
    mfa_code_invalid: 'Codice non valido. Scrivi il codice attuale dell’app.',
    rate_limited: 'Troppi codici sbagliati. Riprova tra 15 minuti.',
    catalog_unchanged: 'La bozza è uguale alla versione in vigore.',
    catalog_no_draft: 'Salva la bozza prima di pubblicare.',
  },
  /** Segno dei valori sotto il costo. */
  belowCost: 'Prezzo sotto il costo stimato',
  /** Etichette sì/no. */
  yes: 'Sì',
  no: 'No',
  /** Prezzi dei modelli (ADR 0063). */
  models: {
    help: 'Prezzi standard delle API di Claude in dollari per milione di token. Danno il valore in crediti del consumo e il prezzo dei token oltre i limiti del piano.',
    model: 'Modello',
    input: 'Input',
    output: 'Output',
    cache_write_5m: 'Scrittura in cache, 5 minuti',
    cache_write_1h: 'Scrittura in cache, 1 ora',
    cache_read: 'Lettura dalla cache',
  },
};
